import { ReplyComment } from '@components/ArtBoard/Threads/components/ReplyComment'
import type { ID } from '@octopus-do/octopus-project-core'
import { ScrollbarCls } from '@octopus-do/octopus-storybook'
import type { Thread } from '@store/reducers/threads'
import type React from 'react'

import type { Comment, Recipient } from '@/types'
import { clsJoin } from '@/utils'
import { InitialComment } from '../InitialComment'
import { ReplyEditor } from '../ReplyEditor'
import css from './styles.module.css'

interface Props {
  thread: Thread
  comments: Comment[]
  users: Record<ID, Recipient>
}

// the list scrolls inside the card, the reply field stays pinned below it;
// the list opens on the newest comment and follows a reply as it lands; the
// wheel over the card scrolls it rather than the canvas
export const ThreadComments: React.FC<Props> = ({
  thread,
  comments,
  users,
}) => (
  <div className={css.thread_card} data-own-wheel>
    <div className={clsJoin(css.comments, ScrollbarCls)}>
      <div className={css.list}>
        <InitialComment thread={thread} users={users} />
        {comments.map((c) => (
          <ReplyComment comment={c} users={users} key={c.id} />
        ))}
      </div>
    </div>
    <ReplyEditor key={comments.length} threadId={thread.uuid} />
  </div>
)
